import {Injectable} from "@angular/core";
import {MessageStream} from "../message-stream/message-stream";
import {CustomWidgetData} from "../../types/custom-widgets/custom-widget-data";

@Injectable()
export class AddCustomWidgetService extends MessageStream<CustomWidgetData> {
  constructor() {
    super();
  }
}
